import { TasksListScreenContent } from "../../features/tasksList";

function TasksListScreen() {
  return (
    <section
      className="clients-page feature-tasks-list-page"
      id="Csection"
      tabIndex="-1"
    >
      <div className="container">
        <TasksListScreenContent />
      </div>
    </section>
  );
}

export default TasksListScreen;
